export default "__VITE_ASSET__CshcXcMU__"